import { inject, observer } from 'mobx-react';
import { ApplicationStoreKey, IApplicationStore } from '../../liveStores';
import { TicketDetailMyTicketForVGBaseContainer } from './ticketDetailForVGContainer';


@inject(ApplicationStoreKey)
@observer
export class LiveTicketDetailMyTicketForVGContainer extends TicketDetailMyTicketForVGBaseContainer {
    componentWillMount() {
        (this.props.applicationStore as IApplicationStore).setCanShowLeftColumn(true);
        super.componentWillMount();
    }
}
